import { googleLogin, login } from './_duck'
import * as types from './types'

// Types
import {
  ModuleTypeLoginGoogle
} from './_definitions'
import { PayloadAction } from '../../types'


const initialModuleStateLoginGoogle: ModuleTypeLoginGoogle = {
  hasErrMessage: false,
  loginGoogleSuccess: null,
  statusLoginGoogle: null,
  loadingGoogleLogin: false,
}

const reducerGoogle = googleLogin.createReducer(
  {
    [types.LOGIN_WITH_GOOGLE_REQUEST]: (
      state: ModuleTypeLoginGoogle,
    ): ModuleTypeLoginGoogle => ({
      ...state,
      hasErrMessage: false,
      loadingGoogleLogin: true,
    }),
    [types.LOGIN_WITH_GOOGLE_SUCCESS]: (
      state: ModuleTypeLoginGoogle,
      { payload }: PayloadAction,
    ): ModuleTypeLoginGoogle => ({
      ...state,
      loginGoogleSuccess: true,
      statusLoginGoogle: payload,
      loadingGoogleLogin: false,
    }),
    [types.LOGIN_WITH_GOOGLE_FAILURE]: (
      state: ModuleTypeLoginGoogle,
    ): ModuleTypeLoginGoogle => ({
      ...state,
      hasErrMessage: true,
      loginGoogleSuccess: false,
      loadingGoogleLogin: false,
    }),
    [types.LOGIN_WITH_GOOGLE_CLEAN]: (
      state: ModuleTypeLoginGoogle,
    ): ModuleTypeLoginGoogle => ({
      ...state,
      loginGoogleSuccess: null,
    }) 
  },
  {
    initialModuleStateLoginGoogle,
  },
)

export default reducerGoogle
